import { stripHtml } from './stripHtml'

export const computeTimeToRead = (content: string): string => {
  const text = stripHtml(content)
  const words = text ? text.split(/\s+/).filter(Boolean).length : 0
  const minutes = Math.max(1, Math.round(words / 200))
  return `PT${minutes}M`
}
